import React from "react";
import { Helmet } from 'react-helmet';

import ReactMapsGl from "./components/ReactMapsGl";

function App() {
  return (
  <>
    <Helmet>
      <link
        href="https://fonts.googleapis.com/css?family=Heebo:400,500,700,800,900&display=swap"
        rel="stylesheet"
      />
    </Helmet>
    <ReactMapsGl></ReactMapsGl>
  </>
  );
}

export default App;
